import { Injectable } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormArray,
  AbstractControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import * as jwtDecode from "jwt-decode";
import { Hierarchy } from "hierarchy";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "shared/confirmation-dialog/confirmation-dialog.component";
import { BannerComponent } from "shared/banner/banner.component";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { take } from "rxjs/operators";
import { AssignDialogComponent } from "shared/assign-dialog/assign-dialog.component";
import { UnderscorePipe } from "pipes/underscore.pipe";
import { TitleCasePipe } from "@angular/common";
import { AssignUserDialogComponent } from "shared/assign-user-dialog/assign-user-dialog.component";
import { ConfirmationDialogsComponent } from "shared/confirmation-dialogs/confirmation-dialogs.component";
import { AlertMessageComponent } from "shared/alert-message-dialog/alert-message.component";
import { ViewPdfVideoComponent } from "shared/view-pdf-video/view-pdf-video.component";
//import { AssignUserDialogComponent } from 'shared/assign-user-dialog/assign-user-dialog.component';
import { Location } from '@angular/common';

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  constructor(
    private location: Location,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private underscorePipe: UnderscorePipe,
    private titlecasePipe: TitleCasePipe,
    private fb: FormBuilder // don't remove this fb here it is used by other component with bind this
  ) {
    this.setTokenData();
  }

  tokenData;
  accessData;
  contact;
  profileName: Observable<string>;
  profileImage: Observable<string> = of("assets/man.png");
  hierarchy = [];

  refresh$ = new Subject();
  resetPaginator$ = new Subject();
  sanctionListData = new Subject();
  snaList = new Subject();

  setTokenData() {
    const navigation = localStorage.getItem('navigation');
    this.tokenData = localStorage.getItem("token")
      ? jwtDecode(localStorage.getItem("token"))
      : null;
    if (this.tokenData && navigation != 'forget-password') {
      this.setAccessData();
      // console.log(this.tokenData);
    }
  }
  // accessName
  getTokenData() {
    return this.tokenData;
  }
  setAccessData() {
    const hierarchy = new Hierarchy(this.tokenData?.hierarchy);
    if (hierarchy) {
      const accessData = {
        ULBCode: hierarchy.getUlb().getCode(),
        ULBId: hierarchy.getUlb().getId(),
        ULBName: hierarchy.getUlb().getName(),
        censusCode: hierarchy.getUlb().getCode(),
        districtCode: hierarchy.getDistrict().getCode(),
        districtId: hierarchy.getDistrict().getId(),
        districtName: hierarchy.getDistrict().getName(),
        districtShortName: hierarchy.getDistrict().getShortName(),
        stateCode: hierarchy.getState().getCode(),
        stateId: hierarchy.getState().getId(),
        stateName: hierarchy.getState().getName(),
        stateShortName: hierarchy.getState().getShortName(),
      };
      this.accessData = accessData;
      const { state, district, ulb, ward, area } = this.tokenData?.hierarchy;
      this.hierarchy = [state, district, ulb, ward, area];
      this.refresh$.next();
    }
  }
  getContactId() {
    return this.getProfileDetail()?.contact || null;
  }

  setContactDetails(contact) {
    this.contact = contact;
    // console.log(this.contact);
    localStorage.setItem('p_form_access', JSON.stringify(this.contact.FormAccessData
    ));
  }


  getAccessDataForm(value: any) {
    console.log(value);
    
    // const getValueFormAccess = JSON.parse(localStorage.getItem('p_form_access'));
     const getValueFormAccess = [{ "id": 34, "form_title": "bulk-upload", "ViewAccess": 1, "EditAccess": 1 }, { "id": 33, "form_title": "soak-pit-arrangement", "ViewAccess": 1, "EditAccess": 1 }, { "id": 32, "form_title": "vehicle-sanitary-shed", "ViewAccess": 1, "EditAccess": 1 }, { "id": 31, "form_title": "life-campaign", "ViewAccess": 1, "EditAccess": 1 }, { "id": 30, "form_title": "sewerlines", "ViewAccess": 1, "EditAccess": 1 }, { "id": 29, "form_title": "pumping-stations", "ViewAccess": 1, "EditAccess": 1 }, { "id": 28, "form_title": "interceptions-diversion", "ViewAccess": 1, "EditAccess": 1 }, { "id": 27, "form_title": "drain", "ViewAccess": 1, "EditAccess": 1 }, { "id": 26, "form_title": "sewage", "ViewAccess": 1, "EditAccess": 1 }, { "id": 25, "form_title": "operation-maintenance", "ViewAccess": 1, "EditAccess": 1 }, { "id": 24, "form_title": "swd", "ViewAccess": 1, "EditAccess": 1 }, { "id": 23, "form_title": "ghats", "ViewAccess": 1, "EditAccess": 1 }, { "id": 22, "form_title": "water-bodies", "ViewAccess": 1, "EditAccess": 1 }, { "id": 21, "form_title": "transfer-station", "ViewAccess": 1, "EditAccess": 1 }, { "id": 20, "form_title": "secondary-storage", "ViewAccess": 1, "EditAccess": 1 }, { "id": 19, "form_title": "dumpsite", "ViewAccess": 1, "EditAccess": 1 }, { "id": 18, "form_title": "landfill", "ViewAccess": 1, "EditAccess": 1 }, { "id": 17, "form_title": "plant", "ViewAccess": 1, "EditAccess": 1 }, { "id": 16, "form_title": "bulk-wastes", "ViewAccess": 1, "EditAccess": 1 }, { "id": 15, "form_title": "non-bwg", "ViewAccess": 1, "EditAccess": 1 }, { "id": 14, "form_title": "area-swm", "ViewAccess": 1, "EditAccess": 1 }, { "id": 13, "form_title": "area-building", "ViewAccess": 1, "EditAccess": 1 }, { "id": 12, "form_title": "safai-surkcha-details", "ViewAccess": 1, "EditAccess": 1 }, { "id": 11, "form_title": "safai-surkcha-declaration", "ViewAccess": 1, "EditAccess": 1 }, { "id": 10, "form_title": "notification-management", "ViewAccess": 1, "EditAccess": 1 }, { "id": 9, "form_title": "shg-master", "ViewAccess": 1, "EditAccess": 1 }, { "id": 8, "form_title": "vehicle-master", "ViewAccess": 1, "EditAccess": 1 }, { "id": 7, "form_title": "work-force-master", "ViewAccess": 1, "EditAccess": 1 }, { "id": 6, "form_title": "area-master", "ViewAccess": 1, "EditAccess": 1 }, { "id": 5, "form_title": "ward-detail", "ViewAccess": 1, "EditAccess": 1 }, { "id": 4, "form_title": "ward-master", "ViewAccess": 1, "EditAccess": 1 }, { "id": 3, "form_title": "zone-master", "ViewAccess": 1, "EditAccess": 1 }, { "id": 2, "form_title": "city-level-details", "ViewAccess": 1, "EditAccess": 1 }, { "id": 1, "form_title": "about-city", "ViewAccess": 1, "EditAccess": 1 }];
    const data = getValueFormAccess.filter((i: any) => i.form_title === value);
    // alert(JSON.stringify(data))
    return data;
  }

  getContactDetail() {
    return this.contact;
  }

  getAccessData() {
    return this.accessData;
  }
  getUlbCode() {
    return this.accessData?.ULBCode;
  }
  getDistrictCode() { 
    return this.accessData?.districtId;
  }
  getUlbName() {
    return this.accessData?.ULBName;
  }
  getStateCode() {
    return this.accessData?.stateCode;
  }
  getHierarchy(): Array<any> {
    return this.hierarchy;
  }

  getProfileDetail() {
    const profile = this.tokenData?.profile;
    return profile;
  }

  getUser() {
    return this.tokenData.username;
  }
  getUserId() {
    return this.tokenData.userId;
  }
  getAccessName() {
    //console.log(this.tokenData.access.accessName);
    return this.tokenData.access.accessName;
  }
  //newly added for national access
  getNationalAccess() {
    console.log("National Access", this.tokenData?.access?.accessName);
    return this.tokenData?.access?.accessName;
  }
  getUserRole() {
    return this.tokenData ? this.tokenData.authority : "admin";
  }
  getAccessLevel() {
    return this.tokenData?.access?.access;
  }
  getUserAccess() {
    return this.tokenData?.accessSource?.code;
  }
  getUserDesignation() {
    return this.tokenData?.access?.designation?.name;
  }
  isUlbAccess() {
    return this.getAccessLevel() === "ULB" &&
      this.tokenData.authority === "OFFICIAL"
      ? true
      : false;
  }
  isStateAccess() {
    return this.getAccessLevel() === "STATE" &&
      this.tokenData.authority === "OFFICIAL"
      ? true
      : false;
  }
  isDistrictAccess() {
    return this.getAccessLevel() === "DISTRICT" &&
      this.tokenData.authority === "OFFICIAL"
      ? true
      : false;
  }
  isNationalAccess() {
    return this.getAccessLevel() === "NATIONAL" &&
      this.tokenData.authority === "OFFICIAL"
      ? true
      : false;
  }
  isSuperAdminAccess() {
    return this.tokenData?.access?.accessId === "UA-1585945422634";
  }
  isCentralAccess() {
    return this.isNationalAccess() || this.isSuperAdminAccess();
  }

  hasEditAccess() {
    if (
      this.tokenData?.access?.accessId === "UA-1606312218"
      // INFO uncomment below lines to to disable edit access to ULBs/State respectively
      // || this.isUlbAccess()
      // || this.isStateAccess()
    ) {
      return false;
    }
    return true;
  }
  hasDeleteAccess() {
    if (
      this.tokenData?.access?.accessId === "UA-1606312218"
      // INFO uncomment below lines to to disable delete access to ULBs/State respectively
      // || this.isUlbAccess()
      // || this.isStateAccess()
    ) {
      return false;
    }
    return true;
  }
  clearLogin() {
    this.tokenData = null;
    this.accessData = null;
    this.hierarchy = null;
  }
  initDisabledControl(val = null) {
    const control = new FormControl(val);
    control.disable();
    return control;
  }
  toggleAccessControls(
    state: AbstractControl,
    district: AbstractControl,
    ulb: AbstractControl
  ) {
    if (this.getAccessLevel() === "ULB") {
      this.disableControls([state, district, ulb]);
    } else if (this.getAccessLevel() === "DISTRICT") {
      this.disableControls([state, district]);
    } else if (this.getAccessLevel() === "STATE") {
      this.disableControls([state]);
    }
  }
  errorMessage(err) {
    if (err instanceof HttpErrorResponse) {
      const message =
        err.error?.errorMessage ||
        err.error?.responseMessage ||
        err.error.error;
      if (
        (err.status === 404 || err.status === 401) &&
        err.error.errorMessage
      ) {
        if (
          message === "Invalid username or JWT token" ||
          message === "Invalid token unauthorised access." ||
          message === "jwt malformed"
        ) {
          this.showMsg("Your Session has Expired", "");
          setTimeout(() => {
            localStorage.clear();
            this.clearLogin();
            this.router.navigateByUrl("/u/login");
            this.showMsg("Login to Continue", "");
          }, 4000);
        } else {
          if (message) {
            return this.showMsg(message, "Error");
          }
        }
        return message;
      } else if (err.status === 0) {
        console.log("Server Unreachable");
        console.log(
          "<<<<<<<<<<<<<<<<<<<<<<<<<<<No Connection>>>>>>>>>>>>>>>>>>",
          err
        );
        console.log("Please check your connection.....");
        this.showMsg("Looks like you are not connected.....", "");
        return setTimeout(() => {
          console.log("Please check your connection.....");
          this.showMsg("Please check your connection.....", "");
        }, 5000);
      }
      if (message) {
        return this.showError(message);
      } else {
        this.showError("Invalid File or Input", "");
      }
    }
  }

  showMsg(
    msg: string,
    type: string = "Success",
    duration = 5500,
    verticalPosition: MatSnackBarVerticalPosition = "bottom"
  ) {
    this.snackbar.open(msg, type, { duration, verticalPosition });
  }
  showError(msg: string, type: string = "Error", duration = 5500) {
    this.snackbar.open(msg ? msg : "Some Error Occured..!", type, { duration });
  }

  toBoolean(val): boolean {
    if (
      val === true ||
      val === "true" ||
      val === "active" ||
      val === 1 ||
      val === "1"
    ) {
      return true;
    } else {
      return false;
    }
  }
  toOneZero(val): string {
    if (
      val === true ||
      val === "true" ||
      val === "active" ||
      val === 1 ||
      val === "1"
    ) {
      return "1";
    } else {
      return "0";
    }
  }
  toYesNo(val) {
    const check = this.toBoolean(val);
    if (check) {
      return "Yes";
    }
    return "No";
  }
  // Evaluate total from the values in a group
  evaluateGroupTotal(group: FormGroup) {
    const values = Object.values(group.value);
    return values
      .map((val) => +(val ? val : 0))
      .reduce((acc, value) => acc + +(value ? value : 0), 0);
  }
  // Evaluate total from given controls
  evaluateControlTotal(controls: FormControl[]) {
    return controls
      .map((c) => +(c.value ? c.value : 0))
      .reduce((acc, value) => acc + +(value ? value : 0), 0);
  }

  evaluateSum(input: Array<any>) {
    const arr = input.map((i) => +i);
    return arr
      .map((val) => +(val ? val : 0))
      .reduce((acc, value) => acc + +(value ? value : 0), 0);
  }

  nullCheckObj(obj) {
    const newObj: any = {};
    for (const [key, value] of Object.entries(obj)) {
      if (
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== "null" &&
        obj[key] !== "undefined" &&
        obj[key] !== "" &&
        obj[key] !== "NA"
      ) {
        newObj[key] = value;
      }
    }
    return newObj;
  }

  checkArray(val) {
    return Array.isArray(val)
      ? val
      : typeof val === "string"
        ? Array.isArray(this.checkJSONStringified(val))
          ? JSON.parse(val)
          : []
        : [];
  }

  checkJSONStringified(data: string) {
    let obj = {};
    try {
      obj = JSON.parse(data);
    } catch {
      obj = {};
    }
    return obj;
  }

  isEmptyObject(obj) {
    if (
      !Object.getOwnPropertySymbols(obj).length &&
      !Object.getOwnPropertyNames(obj).length
    ) {
      return true;
    }
    return false;
  }

  removeValidations(control: FormControl | AbstractControl) {
    control.clearValidators();
    control.updateValueAndValidity();
  }
  setControlsRequired(
    controls: FormControl[] | AbstractControl[],
    enable = true
  ) {
    controls?.forEach((control) => {
      if (enable) {
        control?.enable();
      }
      control?.setValidators(Validators.required);
      control?.updateValueAndValidity();
    });
  }
  removeRequired(controls: FormControl[] | AbstractControl[]) {
    controls.forEach((control) => {
      control.clearValidators();
      control.updateValueAndValidity();
    });
  }
  clearControls(control: FormControl[] | AbstractControl[]) {
    control.forEach((i) => i.reset());
  }
  updateControls(control: FormControl[] | AbstractControl[]) {
    control.forEach((i) => i.updateValueAndValidity());
  }

  enableControls(control: FormControl[] | AbstractControl[]) {
    control.forEach((i) => i.enable());
  }
  disableControls(control: FormControl[] | AbstractControl[]) {
    control.forEach((i) => i.disable());
  }

  setFormArrayValue(arr: FormArray, initGroup, data: Array<any>) {
    for (let i = 1; i <= data.length - 1; i++) {
      arr.push(initGroup());
    }
    arr.patchValue(data);
  }

  findInvalidControls(form: FormGroup | FormArray): string[] {
    const invalid: string[] = [];
    const recursiveFunc = (form: FormGroup | FormArray) => {
      Object.keys(form.controls).forEach((field) => {
        const control = form.get(field);
        if (control.invalid) {
          invalid.push(field);
        }
        if (control instanceof FormGroup) {
          recursiveFunc(control);
        } else if (control instanceof FormArray) {
          recursiveFunc(control);
        }
      });
    };
    recursiveFunc(form);
    return invalid;
  }

  scrollToError(): void {
    const errorElements = document.querySelector(
      ".ng-invalid:not(form), .error"
    );
    if (errorElements) {
      this.scrollTo(errorElements);
    }
  }
  scrollTo(el: Element, block: ScrollLogicalPosition = "center"): void {
    el.scrollIntoView({ behavior: "smooth", block });
  }
  setAsTouched(group: FormGroup | FormArray) {
    group.markAsTouched();
    for (const i in group.controls) {
      if (group.controls[i] instanceof FormControl) {
        group.controls[i].markAsTouched();
      } else {
        this.setAsTouched(group.controls[i]);
      }
    }
  }

  clearFormArray(arr: FormArray) {
    while (arr.length !== 0) {
      arr.removeAt(0);
    }
  }

  getLastNyears(date: Date, n: number) {
    const years = [];
    for (let i = 0; i < n; i++) {
      years.push(
        new Date(date.getFullYear() - i, date.getMonth()).getFullYear()
      );
    }
    return years;
  }
  getYearsRange(startYear = 2020, toYear = new Date().getFullYear()) {
    const years = [];
    while (startYear <= toYear) {
      years.push(startYear++);
    }
    return years;
  }
  getLastNmonths(date: Date, n: number, year = null) {
    const formatter = new Intl.DateTimeFormat("default", { month: "long" });
    const months = [];
    for (let i = 0; i < n; i++) {
      if (year) {
        months.push(
          formatter.format(new Date(date.getFullYear(), date.getMonth() - i))
        );
      } else {
        months.push(
          formatter.format(new Date(date.getFullYear(), date.getMonth() - i))
        );
      }
    }
    return months;
  }
  getOnlyDate(date) {
    return date.split("T")[0];
  }
  getMonthOptions() {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat("default", { month: "long" });
    const months = [];
    for (let i = 0; i < 12; i++) {
      months.push({
        month: i,
        name: formatter.format(new Date(date.getFullYear(), i)),
      });
    }
    return months;
  }

  daysInMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  getMonthName(date: Date) {
    const formatter = new Intl.DateTimeFormat("default", { month: "long" });
    const month = formatter.format(
      new Date(date.getFullYear(), date.getMonth())
    );
    return month;
  }

  splitAtIndex(arr: Array<any>, i: number) {
    return [arr.slice(0, i), arr.slice(i, i + arr.length)] || [];
  }

  isoString(val) {
    if (val !== "") {
      return new Date(val).toISOString();
    }
    return "";
  }
  timeStamp(val) {
    if (val !== "") {
      return new Date(val).getTime();
    }
    return "";
  }
  localString(val: string): string {
    if (val !== "") {
      const date = new Date(val);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  }
  setDate(val) {
    if (
      val &&
      (val !== "" ||
        val !== null ||
        val !== undefined ||
        val !== "undefined" ||
        val !== "null" ||
        !isNaN(val) ||
        val !== "NaN")
    ) {
      return new Date(parseInt(val, 10));
    }
    return "";
  }
  isRequired(abstractControl: AbstractControl) {
    if (abstractControl?.validator) {
      const validator = abstractControl.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    return false;
  }

  assign(
    head: string,
    options: Array<any>,
    assigned: string[],
    rest: any = {}
  ): Observable<any> {
    const dialogRef = this.dialog.open(AssignDialogComponent, {
      width: rest.width ? rest.width : "550px",
      data: { head, options, assigned, ...rest },
    });
    return dialogRef.afterClosed();
  }
  userAssign(
    head: string,
    options: Array<any>,
    assigned: string[],
    rest: any = {}
  ): Observable<any> {
    const dialogRef = this.dialog.open(AssignUserDialogComponent, {
      width: rest.width ? rest.width : "550px",
      data: { head, options, assigned, ...rest },
    });
    return dialogRef.afterClosed();
  }
  confirm(head: string, body: string, rest: any = {}): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: rest.width ? rest.width : "450px",
      data: {
        head,
        body: rest.replace ? this.replaceAll(body) : body,
        ...rest,
      },
    });
    return dialogRef.afterClosed();
  }

  alertMessage(head: string, body: string, rest: any = {}): Observable<any> {
    const dialogRef = this.dialog.open(AlertMessageComponent, {
      width: rest.width ? rest.width : "650px",
      data: {
        head,
        body: rest.replace ? this.replaceAll(body) : body,
        ...rest,
      },
    });
    return dialogRef.afterClosed();
  }

  confirmCheckbox(head: string, body: string, rest: any = {}): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmationDialogsComponent, {
      width: rest.width ? rest.width : "450px",
      data: {
        head,
        body: rest.replace ? this.replaceAll(body) : body,
        ...rest,
      },
    });
    return dialogRef.afterClosed();
  }
  confirmDelete(
    rest = {},
    head = "Confirm Delete",
    msg = "Are you sure you want to delete?"
  ): Observable<any> {
    return this.confirm(head, msg, { ...rest, delete: true });
  }

  bulkUploadDialog(
    rest = {},
    head = "Bulk Upload",
    body = BULK_BODY
  ): Observable<any> {
    const obj = { ...rest, isBulkUpload: true, width: "650px" };
    return this.confirm(head, body, obj);
  }

  bulkUploadDialogForce(rest = {}): Observable<any> {
    const obj = { ...rest, isBulkUpload: true, width: "650px" };
    return this.confirm(
      "Bulk Upload",
      `Please upload correct excel file (.xlsx , .xls, .csv) and make sure that the data is as  per the given structure provided in the template,
      if data is not appropriate it may be rejected by the server.
      You can always check the status of your uploaded documents from the bulk upload status section`,
      obj
    );
  }

  preview(head: string, fileUrls: string[], rest: any = {}): Observable<any> {
    const dialogRef = this.dialog.open(BannerComponent, {
      width: rest.width ? rest.width : "850px",
      data: { head, fileUrls, ...rest },
    });
    return dialogRef.afterClosed();
  }

  previewPdfVideo(
    head: string,
    fileUrls: any,
    rest: any = {}
  ): Observable<any> {
    const dialogRef = this.dialog.open(ViewPdfVideoComponent, {
      width: rest.width ? rest.width : "850px",
      data: { head, fileUrls, ...rest },
    });
    return dialogRef.afterClosed();
  }

  cancelBackToList(
    group: FormGroup,
    route: ActivatedRoute,
    isListingAllowed = true
  ) {
    const routeTo = isListingAllowed ? ["../"] : ["/user", this.getUserRole()];
    const navigate = () => {
      this.location.back()
      // this.router.navigate(routeTo, { relativeTo: route });
    };
    if (group?.dirty) {
      this.confirm(
        "Cancel",
        `Are you sure you want to cancel, any unsaved changes would be discarded?`
      )
        .pipe(take(1))
        .subscribe((confirmed) => {
          if (confirmed) {
            return navigate();
          }
        });
    } else {
      return navigate();
    }
  }
  cancelBackToList2(
    group: FormGroup,
    route: ActivatedRoute,
    isListingAllowed = true
  ) {
    const routeTo = isListingAllowed
      ? ["../list"]
      : ["/user", this.getUserRole()];
    const navigate = () => {
      this.router.navigate(routeTo, { relativeTo: route });
    };
    if (group?.dirty) {
      this.confirm(
        "Cancel",
        `Are you sure you want to cancel, any unsaved changes would be discarded?`
      )
        .pipe(take(1))
        .subscribe((confirmed) => {
          if (confirmed) {
            return navigate();
          }
        });
    } else {
      return navigate();
    }
  }

  getOptionsFromEnums(enums: Array<string>) {
    return enums.map((value) => {
      return {
        option: this.titlecasePipe.transform(
          this.underscorePipe.transform(value)
        ),
        value,
      };
    });
  }

  // Check for Updated values in a form
  getUpdates(
    formItem: FormGroup | FormArray | FormControl,
    updatedValues: any,
    name?: string
  ) {
    if (formItem instanceof FormControl) {
      if (name && formItem.dirty) {
        updatedValues[name] = formItem.value;
      }
    } else {
      for (const formControlName in formItem.controls) {
        if (formItem.controls.hasOwnProperty(formControlName)) {
          const formControl = formItem.controls[formControlName];

          if (formControl instanceof FormControl) {
            this.getUpdates(formControl, updatedValues, formControlName);
          } else if (
            formControl instanceof FormArray &&
            formControl.dirty &&
            formControl.controls.length > 0
          ) {
            updatedValues[formControlName] = [];
            this.getUpdates(formControl, updatedValues[formControlName]);
          } else if (formControl instanceof FormGroup && formControl.dirty) {
            updatedValues[formControlName] = {};
            this.getUpdates(formControl, updatedValues[formControlName]);
          }
        }
      }
    }
  }
  getFileExtention(url): string {
    return url.split(/[#?]/)[0].split(".").pop().trim().split("/")[0] || "";
  }
  replaceAll(str, mapObj = { BOLD_TEXT: "<strong>", BOLD_END: "</strong>" }) {
    const re = new RegExp(Object.keys(mapObj).join("|"), "gi");
    return str.replace(re, (matched) => mapObj[matched]);
  }
  evaluatePercent(val, total) {
    return ((+val / total) * 100).toFixed(2);
  }

  setFilterInDb(value) {
    localStorage.setItem('filterValue', JSON.stringify(value));
  }
  clearFilterInDb() {
    localStorage.removeItem('filterValue');
  }


  getFilterData() {
    try {
      return JSON.parse(localStorage.getItem('filterValue') || 'null');
    } catch (e) {
      console.error('Error reading filter value from localStorage:', e);
      return null;
    }
  }


  isfilterValue() {
    try {
      return localStorage.getItem('filterValue') !== null;
    } catch (e) {
      console.error('Error checking filter value in localStorage:', e);
      return false;
    }
  }

  removefilterValue() {
    try {
      return localStorage.removeItem('filterValue');
    } catch (e) {
      console.error('Error remove filter value in localStorage:', e);
      return false;
    }
  }


  isfilterValueAssesor() {
    try {
      return localStorage.getItem('filterValueAccessor') !== null;
    } catch (e) {
      console.error('Error checking filter value in localStorage:', e);
      return false;
    }
  }

  getFilterDataAssesor() {
    try {
      return JSON.parse(localStorage.getItem('filterValueAccessor') || 'null');
    } catch (e) {
      console.error('Error reading filter value from localStorage:', e);
      return null;
    }
  }

  setFilterInDbAssesor(value) {
    localStorage.setItem('filterValueAccessor', JSON.stringify(value));
  }

  clearFilterInDbAssesor() {
    localStorage.removeItem('filterValueAccessor');
  }

  private loading = new BehaviorSubject<boolean>(false);
  private progress = new BehaviorSubject<number>(0);

  loading$ = this.loading.asObservable();
  progress$ = this.progress.asObservable();

  private interval: any;

//   showLoader() {
//   this.loading.next(true);
//   this.progress.next(0);

//   this.interval = setInterval(() => {
//     const current = this.progress.value;
//     if (current < 90) {
//       this.progress.next(current + Math.random() * 10);
//     }
//   }, 200);
// }

showLoader() {
  this.loading.next(true);
  this.progress.next(0);

  // clear old interval if exists
  if (this.interval) {
    clearInterval(this.interval);
  }

  this.interval = setInterval(() => {
    const current = this.progress.value;
    if (current < 90) {
      this.progress.next(current + Math.random() * 10);
    }
  }, 200);
}

hideLoader() {
  this.progress.next(100);

  this.loading.next(false);   // ✅ immediate
  clearInterval(this.interval);
}

  setProgress(value: number) {
    this.progress.next(value);
  }



}

const BULK_BODY = `Please upload correct excel file (.xls /.xlsx) and make sure that the data is as  per the given structure provided in the template,
if data is not appropriate it may be rejected by the server.
You can always check the status of your uploaded documents from the bulk upload status section`;
